/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SystemManagerExportReturnCodes } from '@hcworkspace/sysque/shared/ui';
import { SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';
import { Observable } from 'rxjs';
import { SystemOptionsReturnCodes } from '../../../../../feature/src/lib/sysque-system-category-options/sysque-system-category-options.component';

export interface ISystemManagerFacade {
  onWindowResize(height: number): void;
  getVisibleInvisibleSystems(): Observable<SystemInfo[]>;
  onExportClick(selectedSystems: string[]): Observable<SystemManagerExportReturnCodes>;
  onSystemManagerItemClick(route: string, width: number, height: number): void;
  browseFile(): Observable<string>;
  updateLocalStorage(key: string, value: any): void;
  getState(): SysqueElectricalState;
  saveSystemsChanges(systems: SystemInfo[]): Observable<SystemOptionsReturnCodes>;
}

export const SYSTEM_MANAGER_FACADE_TOKEN = new InjectionToken<ISystemManagerFacade>('SYSTEM_MANAGER_FACADE_TOKEN');
